import { DEV_SCRIPT_URL, PROD_SCRIPT_URL } from './providers/NitroAds';
import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getNitroSSRConfig(session) {
    var ref;
    if (!session.adsEnabled || !((ref = session.features) === null || ref === void 0 ? void 0 : ref.includes('ads_nitro'))) {
        return {
            shouldIncludeNitro: false,
            nitroUrl: ''
        };
    }
    return {
        shouldIncludeNitro: true,
        nitroUrl: process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm' ? DEV_SCRIPT_URL : PROD_SCRIPT_URL
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
